import { Stack, Typography } from '@mui/material';
import { Frame } from '../../components/layouts/Frame';
import { DashboardCard } from './DashboardCard';
import StripeImage from '../../assets/images/stripe.png';
import OfferImage from '../../assets/images/offer.png';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { Link } from '../../components/global/Link';
import { useEffect, useState } from 'react';
import { CreditData, UserApiData } from '../../types/index';
import { useAPI } from '../../hooks/useAPI';
import { useAuth } from '../../contexts/AuthContext';

export const Dashboard = () => {
  const { fetchData } = useAPI();
  const { isAuthenticated } = useAuth();
  const [credits, setCredits] = useState<CreditData[]>([]);
  const [userApi, setUserApi] = useState<UserApiData>({});

  useEffect(() => {
    if (isAuthenticated) {
      fetchData('/credits').then(({ errors, data }) => {
        setCredits(data);
      });
      fetchData('/user-api').then(({ errors, data }) => {
        setUserApi(data);
      });
    }
  }, [isAuthenticated]);

  return (
    <Frame title="Dashboard">
      <Stack spacing={4}>
        <Stack direction="row" spacing={4}>
          <DashboardCard
            backgroundColor="#C1E6ED"
            title="Credits Remaining"
            value={userApi.credit_remains?.toLocaleString() ?? '-'}
            is_credit={false}
          />
          <DashboardCard
            backgroundColor="#E1CF2E"
            title="Credits Used "
            value={userApi.credit_used?.toLocaleString() ?? '-'}
            is_credit={false}
          />
          <DashboardCard
            backgroundColor="#6FCD9A"
            title="Queries Made"
            value={userApi.query_made?.toLocaleString() ?? '-'}
            is_credit={false}
          />
        </Stack>
        <Stack>
          <Grid2 container>
            <Grid2 xs={12}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography sx={{ fontSize: '36px' }}>Buy Credits</Typography>
                <img style={{ width: 220, height: 70 }} src={StripeImage} />
              </Stack>
              <Typography>Click to buy more credits</Typography>
            </Grid2>
          </Grid2>
          <Stack mt={4}>
            <Grid2 container spacing={4}>
              {credits.map((item, index) => (
                <Grid2 xs={12} sm={6} md={3} lg={4} xl={4} key={index}>
                  <Link
                    to={`/buy-credit/${item.id}`}
                    style={{ textDecoration: 'none' }}>
                    <DashboardCard
                      backgroundColor="#C1E6ED"
                      title={`${item.count?.toLocaleString()} Credits`}
                      value={`&pound; ${item.price?.toLocaleString()}`}
                      is_best_value={item.is_best_value}
                      is_most_popular={item.is_most_popular}
                      is_credit={true}
                      price={item?.price ?? 0}
                      count={item?.count ?? 0}
                      sub_title={item?.sub_title ?? ''}
                    />
                  </Link>
                </Grid2>
              ))}
              <Grid2 xs={12}>
                <Stack direction="row" alignItems="center">
                  <Typography textAlign="center">
                    *20% VAT charged to UK buyers
                  </Typography>
                </Stack>
              </Grid2>
            </Grid2>
          </Stack>
        </Stack>
      </Stack>
    </Frame>
  );
};
